import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ASSETS_FOLDER, SUB_PAGE } from '../../../../../constants';
import { TOP_MENU } from '../../../../../texts';
import { LINKS } from '../../../../../content';
import './CompactBullet.css';
import { setSubPage } from '../../../../../redux/actions';
import { trackEvent } from '../../../../../utils/Stats';

class CompactBullet extends Component {
  constructor(props) {
    super(props);

    // bind
    this.handleClick = this.handleClick.bind(this);
  }

  // -------------------------------------------------------
  // Click
  // -------------------------------------------------------

  handleClick() {
    switch (this.props.id) {
      case 0:
        trackEvent('btnC', 'film');
        break;
      case 1:
        trackEvent('btnC', 'dokument');
        break;
      case 2:
        this.props.setSubPage(SUB_PAGE.MEMORIAL);
        trackEvent('btnC', 'pamatnik');
        break;
      case 3:
        this.props.setSubPage(SUB_PAGE.INFO);
        trackEvent('btnC', 'info');
        break;
      default:
    }
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { id } = this.props;
    const content = (
      <React.Fragment>
        <img
          className="cb-ico"
          src={`${ASSETS_FOLDER}img/scene-compact/bullet-${id}.png`}
          alt={TOP_MENU.LABELS[id]}
        />
        <div className="cb-label">{TOP_MENU.LABELS[id]}</div>
      </React.Fragment>
    );

    // type by id
    if (id < 2) {
      return (
        <a
          className="compact-bullet"
          href={id === 0 ? LINKS.MOVIE : LINKS.DOCUMENT}
          target="_blank"
          rel="noopener noreferrer"
          onClick={this.handleClick}
        >
          {content}
        </a>
      );
    }
    return (
      <button className="compact-bullet" onClick={this.handleClick}>
        {content}
      </button>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  setSubPage: pageId => dispatch(setSubPage(pageId)),
});

export default connect(null, mapDispatchToProps)(CompactBullet);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/SceneCompact/CompactBullet/CompactBullet.js